import React from 'react';
import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";

import useTranslation from "utils/hooks/useTranslation";

export const DHWChoicePopup: React.FC<{
    closePopup: any;
}> = ({
    closePopup,
}) => {
    const { t } = useTranslation();

    return (
        <Popup
            title={t("IDU_HELP_TITLE")}
            translateTitle
            fixSize={"medium"}
            commandPanelProps={{
                additionalElement: (
                    <group data-justify="start" data-gap="20">
                        <Button
                            data-length="forcefit"
                            // accent
                            secondary
                            large
                            onClick={() => {
                                closePopup();
                            }}
                        >
                            {t("CLOSE")}
                        </Button>
                    </group>
                )
            }}
        >
            {/* {isLoading && <Loader />} */}
            <group
                data-direction="column"
                data-gap="20"
                data-space="40"
                data-space-horizontal="40"
                data-space-top="5"
                data-height="autofit"
            >
                <group data-gap="20" data-custom="">
                    <div dangerouslySetInnerHTML={{ __html: t("IDU_HELP") }} />
                </group>
            </group>
        </Popup>
    )
};